export const unformatDate = (date) => {
  const [day, month, year] = date.split("/");
  const dateUnformatted = new Date(+year, +month - 1, +day);
  return dateUnformatted;
};
export const formatDate = (date) => {
  const dayNumber = date.getDate();
  const monthNumber = date.getMonth() + 1;
  const yearNumber = date.getFullYear();
  const DateFormatted = `${dayNumber}/${monthNumber}/${yearNumber}`;
  return { DateFormatted };
};
